import {Component, inject} from '@angular/core';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {SelectMultipleComponent} from '../../shared/components/select-multiple/select-multiple.component';
import {SelectOneComponent} from '../../shared/components/select-one/select-one.component';
import {IdNome} from '../../shared/model/id-nome.model';
import {FilaEsperaFiltro} from '../../shared/model/FilaEsperaFiltro';

@Component({
  selector: 'app-modal-filtro-fila-espera',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SelectMultipleComponent,
    SelectOneComponent
  ],
  templateUrl: './modal-filtro-fila-espera.component.html',
  styleUrl: './modal-filtro-fila-espera.component.css'
})
export class ModalFiltroFilaEsperaComponent {

  atividadeOpcoes: IdNome[] = [
    { id: -1, nome: 'Todos' },
    { id: 1, nome: 'Ativo' },
    { id: 2, nome: 'Inativo' }
  ];

  readonly todos: IdNome = { id: -1, nome: 'Todos' };

  filtro: FilaEsperaFiltro = {
    atendimento: this.todos,
    sessao: this.todos
  };

  private readonly dialog = inject<MatDialogRef<ModalFiltroFilaEsperaComponent>>(MatDialogRef);
  public data = inject(MAT_DIALOG_DATA);

  constructor() {
    if (this.data?.filtros?.atendimento || this.data?.filtros?.sessao) {
      this.filtro = { ...this.data.filtros };
    }
  }

  cancelar() {
    this.dialog.close();
  }

  filtrar() {
    this.dialog.close(this.filtro);
  }
}
